import Chart from 'chart.js/auto'

interface IChartOptions {
  title?: string
  xAxisLabel?: string
  yAxisLabel?: string
  dataset1Label?: string
  dataset2Label?: string
  dataset1Color?: string
  dataset2Color?: string
}

function drawComparisonBarChart(
  canvasContext: any,
  xAxisData: any[],
  dataset1Data: number[],
  dataset2Data: number[],
  options?: IChartOptions,
) {
  let comparisonBarChart: Chart

  // read customized chart options
  let title: any = { display: false }
  let xAxisLabel = ''
  let yAxisLabel = ''
  let dataset1Label = '2025'
  let dataset2Label = '2024'
  let dataset1Color = '#4ade80' // green
  let dataset2Color = '#ef4444' // red

  if (options) {
    if (options.title) {
      title = {
        display: true,
        text: options.title,
        color: '#ffffff',
        font: {
          size: 16,
        },
      }
    }

    if (options.xAxisLabel) {
      xAxisLabel = options.xAxisLabel
    }
    if (options.yAxisLabel) {
      yAxisLabel = options.yAxisLabel
    }
    if (options.dataset1Label) {
      dataset1Label = options.dataset1Label
    }
    if (options.dataset2Label) {
      dataset2Label = options.dataset2Label
    }
    if (options.dataset1Color) {
      dataset1Color = options.dataset1Color
    }
    if (options.dataset2Color) {
      dataset2Color = options.dataset2Color
    }
  }

  // finalize the chart config
  const chartConfig = {
    type: 'bar',
    data: {
      labels: xAxisData,
      datasets: [
        {
          label: dataset1Label,
          data: dataset1Data,
          backgroundColor: dataset1Color,
          borderColor: dataset1Color,
          borderWidth: 1,
        },
        {
          label: dataset2Label,
          data: dataset2Data,
          backgroundColor: dataset2Color,
          borderColor: dataset2Color,
          borderWidth: 1,
        },
      ],
    },
    options: {
      responsive: false,
      plugins: {
        title,
        legend: {
          display: true,
          position: 'bottom' as const,
          labels: {
            color: '#ffffff',
            padding: 20,
            usePointStyle: true,
            pointStyle: 'rectRounded',
          },
        },
        tooltip: {
          mode: 'index' as const,
          intersect: false,
        },
      },
      animation: false,
      scales: {
        x: {
          display: true,
          title: {
            display: !!xAxisLabel,
            text: xAxisLabel,
            color: '#ffffff',
          },
          ticks: {
            color: '#ffffff',
          },
          grid: {
            display: false,
          },
        },
        y: {
          display: true,
          title: {
            display: !!yAxisLabel,
            text: yAxisLabel,
            color: '#ffffff',
          },
          ticks: {
            color: '#ffffff',
            callback: function (value: any) {
              return '$' + value.toLocaleString()
            },
          },
          grid: {
            color: 'rgba(255, 255, 255, 0.1)',
          },
        },
      },
      interaction: {
        mode: 'index' as const,
        intersect: false,
      },
      layout: {
        padding: {
          top: 20,
          right: 20,
          bottom: 20,
          left: 20,
        },
      },
      backgroundColor: '#000000',
    },
  }

  comparisonBarChart = new Chart(canvasContext, chartConfig as any)

  return comparisonBarChart
}

export default drawComparisonBarChart
